import React from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '../context/AppContext';
import { isEmpty } from '../helpers';

export default class Video extends React.Component {
    static contextType = AppContext;

    static propTypes = {
        url: PropTypes.string,
        height: PropTypes.number,
        width: PropTypes.number
    }



    render() {
        const containerStyle = {
            maxHeight: `${this.props.height}px`,
            maxWidth: `${this.props.width}px`
        }

        // get language code (e.g. en-US, fr-CA); default to English if can't find any
        let languageCode = this.context.state.languageCode;
        if (isEmpty(languageCode)) languageCode = "en";

        // get language by splitting the language code into two parts (language + country)
        languageCode = languageCode.split("-")[0]
        languageCode = "en"

        return (
            <div className="video" style={containerStyle} >
                <div className="wrapper" >
                    <iframe
                        frameBorder="0"
                        allowFullScreen={true}
                        scrolling="no"
                        width={this.props.width}
                        height={this.props.height}
                        type="text/html"
                        src={`${this.props.url}?autoplay=0&controls=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0&hl=&cc_lang_pref=${languageCode}&hl=${languageCode}&modestbranding=1`}
                        title="video">
                    </iframe>
                </div>
            </ div>
        );
    }
}

Video.defaultProps = {
    height: 315, width: 560
}


// WEBPACK FOOTER //
// ./src/components/Video.js